<nz-checkbox-wrapper style="width: 100%;"  (nzOnChange)="onCheckboxModelChange($event)" *ngIf="item">
  <div nz-row [ngClass]="{'lhc-vertical': commonUtils.getDisplayControlIsVertical(item.displayControl)}">
    <div *ngFor="let answer of acOptions.listItems; index as i">
      <label
        nz-checkbox
        attr.aria-label="Checkbox {{answer._displayText}} for {{item.question}}"
        (click)="lhcDataService.setActiveRow(item)"
        [nzValue]="item.answers[i]"
        [(ngModel)]="checkboxModels[i]"
        [nzDisabled]="item._readOnly"
        [id]="lhcDataService.getItemAnswerId(item, answer)"
        [style]="answer._obj_CSS">
        <ng-container [ngSwitch]="lhcDataService.getTextDisplayType(answer)">
          <ng-container *ngSwitchCase="'escaped'">{{answer._displayTextHTML}}</ng-container>
          <span *ngSwitchCase="'html'" [outerHTML]="answer._displayTextHTML | safeHtml"></span>
          <span *ngSwitchCase="'markdown'" [outerHTML]="answer._displayTextMarkdown | safeHtml"></span>
          <ng-container *ngSwitchCase="'plain'">{{answer._displayText}}</ng-container>
        </ng-container>
      </label>
    </div>
    <div *ngIf="item.answerConstraint === 'optionsOrString'">
      <label
        nz-checkbox
        attr.aria-label="Checkbox Other for {{item.question}}"
        (click)="lhcDataService.setActiveRow(item)"
        [nzValue]="{'_notOnList': true}"
        [nzDisabled]="item._readOnly"
        [(ngModel)]="otherCheckboxModel"
        [id]="lhcDataService.getItemAnswerId(item, '_other')">
        {{item.openLabel || language.other}}
      </label>
      <div *ngIf="otherCheckboxModel"
           class="{{item._readOnly ? 'lhc-item-readyonly' : null}}"
           [id]="lhcDataService.getItemAnswerId(item, '_otherValue')">
        <input type="text"
               [disabled]="item._readOnly"
               [placeholder]="language.typeToAddMoreValues"
               (focus)="lhcDataService.setActiveRow(item)"
               [id]="lhcDataService.getItemAnswerId(item, '_otherValueInput')"
               #ac
        >
      </div>
    </div>
  </div>
</nz-checkbox-wrapper>

